module.exports = __webpack_public_path__ + "img/svg-edit.png";